//@flow
import React from 'react';
import CustomerModel from '../../Stores/Customer/customerModel';
import OutOfStockReminderProduct from './OutOfStockReminderProduct.react';
import OutOfStockReminderTooltip from './OutOfStockReminderTooltip.react';

import type { List } from 'immutable';

type Props = {
  stockReminders:?List<string>,
  sku:string,
  customer:?CustomerModel,
  showView:?'product'|'tooltip',
  comingSoon:boolean,
};

export default class OutOfStockReminder extends React.Component<Props> {
  hasReminderSet() {
    return this.props.stockReminders && this.props.stockReminders.indexOf(this.props.sku) !== -1;
  }

  getEmail() {
    return this.props.customer && this.props.customer.getEmail();
  }

  getRenderComponent() {
    const props = {
      sku: this.props.sku,
      reminderSet: this.hasReminderSet(),
      email: this.getEmail(),
      customer: this.props.customer,
      comingSoon:this.props.comingSoon,
    };

    switch (this.props.showView) {
      case 'product':
        return (
          <OutOfStockReminderProduct {...props}/>
        );

      case 'tooltip':
        return (
          <OutOfStockReminderTooltip {...props}/>
        );

      default:
        return null;
    }
  }

  render() {
    return this.getRenderComponent();
  }
}
